import { URL } from 'api/constants';

import { BaseRequest } from './types';

export const insertArgsIntoUrl = ({
  id,
  hospitalId,
}: BaseRequest & { id?: string }): string =>
  `${URL.TEAM_USERS.replace('{hospitalId}', hospitalId)}${id ? `/${id}` : ''}`;
